module.exports = __webpack_public_path__ + "assets/img/thumb-Employment-Innovations-Pillar-Page-Resource.cd58bebe.jpg";